import { NbJSThemeOptions } from '@nebular/theme';

export const LITBIT_THEME = {
  name: 'litbit',
  base: 'dark',
} as NbJSThemeOptions;
